import { Component, Input, Output, AfterContentInit, ViewChild, forwardRef, ElementRef, EventEmitter  } from '@angular/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TeamService } from '../_services/generatedServices';
import { TeamListViewModelRead } from '../_models/generatedModels';
import { dynamicSort } from '../_helpers/extensions.module';


@Component({
    selector: 'teams-multiselect',
    host: {
        '[class.rundnaDropdown]': 'someAttr',
    },
    template: `
    <kendo-multiselect #multiselect [placeholder]="placeholder" [clearButton]="false" [valuePrimitive]="true" [textField]="'name'" [valueField]="'id'" [data]="comboData" class="{{cssClass}}" [(ngModel)]="selectedValue" [filterable]="true" (filterChange)="handleFilter($event)" (valueChange)="onChange($event)"></kendo-multiselect>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TeamMultiselectControl),
            multi: true
        }
    ]
})

export class TeamMultiselectControl implements ControlValueAccessor, AfterContentInit {

    someAttr: string = 'anyValue';

    constructor(elementRef: ElementRef, private teamService: TeamService) {
        this.cssClass = elementRef.nativeElement.getAttribute('class');
        elementRef.nativeElement.setAttribute('class', '');
    }

    @Input()
    isDisabled: boolean;

    @Input()
    placeholder: string = "";

    @Output()
    changed = new EventEmitter<number[]>();

    @Output()
    changedObjects = new EventEmitter<TeamListViewModelRead[]>();

    selectedValue: number[] = [];
    comboData: TeamListViewModelRead[] = [];
    teams: TeamListViewModelRead[] = [];
    @ViewChild('multiselect') public multiselect: MultiSelectComponent;
    cssClass: string = '';

    propagateChange = (_: any) => { };
    propagateTouch = () => { };

    writeValue(value: any): void {
        this.selectedValue = value;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateTouch = fn;
    }

    onChange(value: any) {
        this.writeValue(value);
        this.propagateChange(this.selectedValue);
        this.propagateTouch();
        this.changedObjects.emit(this.comboData.filter(x => this.selectedValue.indexOf(x.id!) !== -1).map(x => x as TeamListViewModelRead));
        this.changed.emit(value);
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    ngAfterContentInit(): void {
      this.teamService.getAllTeamsForOrganization().subscribe(results => {
        this.teams = results.sort(dynamicSort('name'));
        this.comboData = this.teams;
      });
  }

    handleFilter(value: any) {
      if (value.length >= 1) {
          this.comboData = this.teams.filter(x => x.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      } else {
          this.comboData = this.teams;
          this.multiselect!.toggle(false);
      }
  }
}
